import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, catchError, filter } from 'rxjs/operators';
import { throwError } from 'rxjs/internal/observable/throwError';

// Providers-Services
import { ApiRestService } from '../services/shared/api-rest.service';
import { NotifyService } from './shared/notify.service';
import { SpinnerService } from './spinner.service';

// import tablas
import { table } from '../components/shared/tables';

@Injectable({
  providedIn: 'root'
})
export class FacturasService {

  constructor(
    private http: HttpClient,
    private _apiRestService: ApiRestService,
    public _notifyService: NotifyService,
    private _spinnerService: SpinnerService
  ) { }

  // Consulta todos los documentos para datatable
  getFacturas() {
    return this.http.get(this._apiRestService.APIURL.serv6 + `/{"tble":"${table.facturas}"}`)
      .pipe(map((res: Response) => {
        let dataUser = { data: res };
        return dataUser;
      })
      );
  }

  public nuevoDocumentoManual(newDoc) {
    let objStr = JSON.stringify(newDoc);
    objStr = objStr.replace(/\//g, 'þ');
    objStr = objStr.replace(/&/g, '¬');
    objStr = encodeURIComponent(objStr);
    console.log("nuevaFactura SERVICIO");
    console.log(newDoc);
    console.log(objStr);
    //console.log(this._apiRestService.APIURL.serv8 + `/{"tble":"${table.prov}","objc":${objStr}}`);
    return this.http.get(this._apiRestService.APIURL.serv8 + `/{"tble":"${table.facturas}","objc":${objStr}}`
    ).pipe(map
      ((res: any) => {
        return res;
      }));
  }

  getFacturaByAtrb(atrb1, opt1, atrb2, opt2) {
    let path;
    //path = this._apiRestService.APIURL.serv6 + `/{"tble":"${table.facturas}","objc":{"${atrb}":"${opt}"}}`
    path = this._apiRestService.APIURL.serv6 + 
  `/{"tble":"${table.facturas}","objc":{"${atrb1}":"${opt1}","${atrb2}":"${opt2}"}}`;

    return this.http.get(path)
      .pipe(map((res: Response) => {
        let dataUser = { data: res };
        return dataUser;
      })
      );
  }

    // Actualizar factura
    public updateFactura(newFac, prnt) {
      let objStr = JSON.stringify(newFac);
      objStr = objStr.replace(/\//g, 'þ');
      objStr = objStr.replace(/&/g, '¬');
      objStr = encodeURIComponent(objStr);
      return this.http.get(this._apiRestService.APIURL.serv8 + `/{"tble":"${table.facturas}","prnt":"${prnt}","objc":${objStr}}`
      ).pipe(map((res: any) => {
        return res;
      })
      );
    }
  
}
